export const AUTHORITY_NO_LIST = {
    SYSTEM_ADMIN: 1,
    USER_ADMIN: 2,
    USER: 3
}
export const RE_LOGIN_MESSAGE = 'ログインの有効期限が切れました、再ログインをお願いします。'
export const ILLEGAL_ROUTE = '正常ではない経路でアクセスされました。'
export const AUTHORITY = [
    "",
    "システム管理者",
    "ユーザー管理者",
    "一般利用者"
]
export const AUTHORITY_LIST = [
    { "value": "", "label": "" },
    { "value": "3", "label": "一般利用者" },
    { "value": "2", "label": "ユーザー管理者" },
    { "value": "1", "label": "システム管理者" }
]

export const AUTHORITY_LIST_USER_ADMIN = [
    { "value": "", "label": "" },
    { "value": "3", "label": "一般利用者" },
    { "value": "2", "label": "ユーザー管理者" },
]

export const LICENSE = [
    "Business",
    "BusinessPro",
    "Enterprise"
]
export const LICENSE_LIST = [
    { "value": "0", "label": LICENSE[0] },
    { "value": "1", "label": LICENSE[1] },
    { "value": "2", "label": LICENSE[2] }
]

export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN === undefined ? 'https://api-dev.dokodemo-doboku.jp/v1/' : process.env.REACT_APP_DOMAIN
// export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN

export const API_URL = {
    USER_LOGIN: REACT_APP_DOMAIN + "cognito/login",
    USER_SEND_CODE: REACT_APP_DOMAIN + "cognito/send-code",
    USER_PASS_RESET: REACT_APP_DOMAIN + "cognito/password-reset",
    USER_GET: REACT_APP_DOMAIN + "users/get",
    USER_LIST: REACT_APP_DOMAIN + "users/list",
    USER_DELETE: REACT_APP_DOMAIN + "users/delete",
    USER_CREATE: REACT_APP_DOMAIN + "users/create",
    USER_UPDATE: REACT_APP_DOMAIN + "users/update",
    FILE_DELETE: REACT_APP_DOMAIN + "file/delete",
    FILE_DOWNLOAD: REACT_APP_DOMAIN + "file/download",
    FILE_ONE_DOWNLOAD: REACT_APP_DOMAIN + "file/one-download",
    FILE_UPLOAD: REACT_APP_DOMAIN + "file/upload",
    DOCUMENT_LIST: REACT_APP_DOMAIN + "document/list",
    CHECKLIST_GET: REACT_APP_DOMAIN + "checklist/get",
    CHECKLIST_LIST: REACT_APP_DOMAIN + "checklist/list",
    CHECKLIST_CREATE: REACT_APP_DOMAIN + "checklist/create",
    CHECKLIST_UPDATE: REACT_APP_DOMAIN + "checklist/update",
    CHECKLIST_DELETE: REACT_APP_DOMAIN + "checklist/delete",
    COMPANY_GET: REACT_APP_DOMAIN + "company/get",
    COMPANY_LIST: REACT_APP_DOMAIN + "company/list",
    COMPANY_CREATE: REACT_APP_DOMAIN + "company/create",
    COMPANY_UPDATE: REACT_APP_DOMAIN + "company/update",
    COMPANY_DELETE: REACT_APP_DOMAIN + "company/delete",
    CONSTRUCTION_GET: REACT_APP_DOMAIN + "construction/get",
    CONSTRUCTION_LIST: REACT_APP_DOMAIN + "construction/list",
    CONSTRUCTION_CREATE: REACT_APP_DOMAIN + "construction/create",
    CONSTRUCTION_UPDATE: REACT_APP_DOMAIN + "construction/update",
    CONSTRUCTION_DELETE: REACT_APP_DOMAIN + "construction/delete",
    INSPECTION_GET: REACT_APP_DOMAIN + "inspection/get",
    INSPECTION_LIST: REACT_APP_DOMAIN + "inspection/list",
    INSPECTION_CREATE: REACT_APP_DOMAIN + "inspection/create",
    INSPECTION_UPDATE: REACT_APP_DOMAIN + "inspection/update",
    INSPECTION_DELETE: REACT_APP_DOMAIN + "inspection/delete",
    BLACKBOARD_CREATE: REACT_APP_DOMAIN + "inspection/blackboard",
    BLACKBOARD_UPDATE: REACT_APP_DOMAIN + "blackboard/update", // 黒板のデザイン変更および変更はこのパスを利用する。
    // 検査画面に入る際は localhost:9000 と url paramsに 各IDを差し込み検査画面デバイスセットアップ画面に入れる。
    CHECK_MEETING_ID: REACT_APP_DOMAIN + "checkMeetingId"
}

export default AUTHORITY;
